import { render } from "./PermissionRoleDetailsPage.vue?vue&type=template&id=c29151ee&scoped=true"
import script from "./PermissionRoleDetailsPage.vue?vue&type=script&lang=js"
export * from "./PermissionRoleDetailsPage.vue?vue&type=script&lang=js"

import "./PermissionRoleDetailsPage.vue?vue&type=style&index=0&id=c29151ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c29151ee"]])

export default __exports__